'use strict';


var mono = "inconsolata, monospace";

exports.mono = mono;
/* No side effect */
